import { TFunction } from 'i18next';
import { ISelectMultiOption } from '@salecycle/ui-component-library';

export interface IStep {
  label: string;
  route: string;
  number: number;
}

export const stepRoutes: string[] = ['/sftp-user', '/summary'];

export const getSteps = (t: TFunction): IStep[] => [
  { label: t('newSftpUser.steps.step1'), route: stepRoutes[0], number: 1 },
  { label: t('newSftpUser.steps.step2'), route: stepRoutes[1], number: 2 },
];

export interface ISftpUser {
  email: string;
  username: string;
  groups?: ISelectMultiOption<string>[];
  brands?: ISelectMultiOption<string>[];
  sites?: ISelectMultiOption<string>[];
  userType: string;
}

export const defaultSftpUser: ISftpUser = {
  username: '',
  email: '',
  userType: 'external',
};
